import {
  parse,
  format,
} from 'date-fns';
import { formatZip9 } from '../../utils/zip9';
import pageView from '../../mixins/pageView';
import destinationManager from '../../mixins/destinationManager';
import staticText from '../../assets/data/staticText.json';
import { choiceAnalytics } from './analytics';
import handleChoice from '../../utils/analytics';
import addressViolations from '../../mixins/addressViolations';
import { redirectToHomePage } from '../../utils/commonUtil';

export default {
  filters: {
    formatPhone(serverString) {
      if (!serverString) return '';
      const areaCode = serverString.substr(0, 3) || '';
      const prefix = serverString.substr(3, 3) || '';
      const suffix = serverString.substr(6) || '';
      return `(${areaCode}) ${prefix}-${suffix}`;
    },
    formatName(names) {
      return names.filter((a) => a).join(' ');
    },
  },
  mixins: [pageView, addressViolations],
  created() {
    this.informedDelivery = JSON.parse(sessionStorage.getItem('informedDelivery') ?? false);
    this.offersChoice = JSON.parse(sessionStorage.getItem('offersChoice') ?? false);
    this.autofillChoice = JSON.parse(sessionStorage.getItem('autofillChoice') ?? false);
    this.extensionSelected = JSON.parse(sessionStorage.getItem('extensionSelected') ?? 0);
    this.myMoveChoicePrefillOptIn = JSON.parse(sessionStorage.getItem('myMoveChoicePrefillOptIn') ?? false);
    this.myMovePrefillOptIn = JSON.parse(sessionStorage.getItem('myMovePrefillOptIn') ?? false);
  },
  async mounted() {
    if (!this.$coa.coaUUID) {
      redirectToHomePage(this);
      return;
    }
    const {
      billingAddressType,
      forwardType,
      moverType,
      ...rest
    } = await this.$coa.coaGet() || {};
    this.coa.billingAddressType = billingAddressType;
    this.coa.forwardType = forwardType;
    this.coa.moverType = moverType;
    this.coa = { ...this.coa, ...rest };
    this.getExtensions();
    if (this.offersChoice) {
      this.additionalSelections.push('save');
    }
    if (this.autofillChoice) {
      this.additionalSelections.push('vr');
    }
    this.pageView();
  },
  data() {
    return {
      coa: {},
      mover: {},
      staticText,
      extension: null,
      myMoveChoicePrefillOptIn: false,
      myMovePrefillOptIn: false,
      informedDelivery: false,
      availableExtensions: [],
      extensionSelected: 0,
      oldAddress: {},
      overrideAms: false,
      newAddress: {},
      offersChoice: null,
      mgoEarlyOptIn: false,
      mgoEarlyOptInNonChoice: false,
      autofillChoice: null,
      multipleBusinesses: false,
      additionalSelections: [],
      choiceSelections: [
        {
          period: 0,
          id: -1,
          cost: 1.1,
          title: 'Identity Verification Fee (Required)',
          required: true,
        },
      ],
      business: [], // stores all business COA with one being marked as primary
      busAddresses: [], // stores all business
      businessAliases: [],
      orderId: null,
      // coaCheck modal
      coaCheckModal: false,
    };
  },
  computed: {
    earlyOptInSelected() {
      return (this.myMoveChoicePrefillOptIn || this.myMovePrefillOptIn) ? '1' : '0';
    },
    choiceAnalytics,
    autofill() {
      return this.myMoveChoicePrefillOptIn || this.myMovePrefillOptIn;
    },
    sdUpdated: () => JSON.parse(sessionStorage.getItem('sdUpdated')),
    medUpdated: () => JSON.parse(sessionStorage.getItem('medUpdated')),
    informedDeliveryEligible() {
      return (
        this.coa.moverType
        && this.coa.moverType !== 'BUSINESS'
        && this.coa.forwardType === 'PERMANENT'
        && this.coa.billingAddressType !== 'OTHER'
      );
    },
    showChoiceExperience: () => JSON.parse(sessionStorage.getItem('showChoiceExperience')),
    showSimplifyExperience: () => JSON.parse(sessionStorage.getItem('showSimplifyExperience')),
    showNonControlExperience: () => JSON.parse(sessionStorage.getItem('showNonControlExperience')),
    skipDisclaimerExperience: () => JSON.parse(sessionStorage.getItem('skipDisclaimerExperience')),
    showExperienceA: () => JSON.parse(sessionStorage.getItem('showExperienceA')),
    showExperienceB: () => JSON.parse(sessionStorage.getItem('showExperienceB')),
    flagAmpersendEnabled() {
      return this.$store.get('flagAmpersendEnabled');
    },
    hasChoiceSelections() {
      return this.choiceSelections.length > 1;
    },
    isPermanent() {
      return this.coa.forwardType !== 'TEMPORARY';
    },
    getPrimaryCOA() {
      const primary = this.business && this.business.length
          && this.business.filter((v) => v.primaryBusiness);
      return primary;
    },
    isMultiBuzPrimaryPermanent() {
      const primaryCoa = this.isMultipleAddressCoa && this.getPrimaryCOA;
      return !!(primaryCoa && primaryCoa[0].forwardType !== 'TEMPORARY');
    },
    showSelections() {
      return this.additionalSelections.length > 0;
    },
    noSelections() {
      return (!this.offersChoice && !this.autofillChoice);
    },
    businessAliasesCost() {
      return (this.businessAliases.length * this.icoaAmount) / 100;
    },
    choiceSelectionsTotal() {
      return this.choiceSelections.reduce((a, c) => a + parseFloat(c.cost ?? c.optionCost), 0);
    },
    flagBusinessAliasEnabled() {
      return this.$store.get('flagBusinessAliasEnabled');
    },
    flagEMFEnabled() {
      return this.$store.get('flagEMFEnabled');
    },
    icoaAmount() {
      return this.$store.get('icoaAmount');
    },
    bizCostComputationEnabled() {
      return this.$store.get('config@bizCostComputationEnabled');
    },
    businessDCOA() {
      return this.coa.moverType === 'BUSINESS' && this.coa.dcoa;
    },
    dateFormat() {
      return 'EEEE, MMMM dd, yyyy';
    },
    isContentHydrated() {
      return (
        this.coa?.uuid
        && this.mover?.uuid
        && this.oldAddress?.uuid
        && this.newAddress?.uuid
      );
    },
    verifyAge() {
      return (
        this.coa.dcoa
        && this.$store.get('config@dobVerificationEnabled')
        && this.coa.forwardType === 'TEMPORARY'
        && this.coa.moverType !== 'BUSINESS'
      );
    },
    coacUrl() {
      return destinationManager.coacUrl;
    },
    enhancedBusinessFlowEnabled() {
      return this.$store.get('config@enhancedBusinessFlowEnabled');
    },
    hasMoreThanOneAddress() {
      return this.business?.length > 1;
    },
    isMultipleAddressCoa() {
      return this.coa.multipleAddresses;
    },
    enhancedBusinessAliasesEnabled() {
      return this.$store.get('config@enhancedBusinessAliasesEnabled');
    },
  },
  methods: {
    handleChoice,
    async coaSync() {
      this.choiceAnalytics.mailForwardingOptOut();
      if (this.coa.multipleAddresses) {
        this.displayPrimary();
        const {
          uuid, orderId, xhr,
        } = await this.$coa.businessCoaUpdate({
          ...this.coa, informedDelivery: this.informedDelivery, earlyOptin: this.earlyOptInSelected,
        });
        if (xhr?.exception || this.fieldErrors?.length) {
          this.$store.commit('DISABLE_LOADER');
          await this.$nextTick();
          this.scrollToFirstError();
          return false;
        }
        const coaCheckHandle = await this.$coa.coaCheckByUUID(uuid);
        // Throw coaCheckModal if 'CoaCheckException'
        if (coaCheckHandle?.error) {
          const { exception } = coaCheckHandle.xhr;
          if (exception === 'CoaCheckException') {
            this.coaCheckModal = true;

            if (!this.coa.primaryBusiness) {
              await this.deleteBusinessCOAByOrderId(orderId);
            }

            this.defaultException('DUPCOAEXCEPTION');
            this.$store.commit('DISABLE_LOADER');
            return false;
          }
        }
      } else {
        this.$coa.coaUpdate({
          ...this.coa, informedDelivery: this.informedDelivery, earlyOptin: this.earlyOptInSelected,
        });
      }
      return true;
    },
    async handleEarlyOptInNoChoice() {
      this.mgoEarlyOptInNonChoice = !this.mgoEarlyOptInNonChoice;
    },
    async handleEarlyOptIn() {
      this.mgoEarlyOptIn = !this.mgoEarlyOptIn;
    },
    async getExtensions() {
      // prevent EMF if disabled
      if (!this.flagEMFEnabled) return;

      const resp = await this.$coa.extensionPrescreen({
        orderUuid: this.$coa.coaUUID,
        forwardType: this.coa?.forwardType,
        dcoa: this.coa?.dcoa,
        mcoa: this.coa?.mcoa,
        oldZip5: this.oldAddress?.amsZip5,
        newZip5: this.newAddress?.amsZip5,
      });

      if (resp?.eligible) {
        const {
          availableExtensions,
        } = await this.$coa.extensionGetAll(this.coa?.visitId);

        this.extensions = availableExtensions || [];

        const extension = availableExtensions.filter(
          (e) => e.optionId === this.extensionSelected,
        ).pop();
        if (this.informedDelivery && this.informedDeliveryEligible) {
          this.choiceSelections.push({
            period: 0,
            id: 0,
            cost: '0',
            title: 'Informed Delivery',
          });
        }
        if (extension) {
          this.choiceSelections.push({
            ...extension,
            get title() { return `${extension?.optionPeriod}-month Mail Forwarding Extension`; },
            get id() { return extension?.optionId; },
          });
        }
      }
    },
    async removeExtensionSelected() {
      this.extensionSelected = 0;
      sessionStorage.removeItem('extensionSelected');
    },
    isMultipleBusinesses(value) {
      this.multipleBusinesses = value;
    },
    parseCost(cost) {
      return cost.cost ?? cost.optionCost;
    },
    isSelected(selection) {
      return this.additionalSelections.includes(selection);
    },
    async removeSelection(event, selection) {
      handleChoice(event);
      if (selection === 'vr') {
        sessionStorage.setItem('autofillChoice', false);
      }
      if (selection === 'save') {
        sessionStorage.setItem('offersChoice', false);
      }
      this.additionalSelections = this.additionalSelections.filter((s) => s !== selection);
    },
    getPrice({ cost }) {
      return cost;
    },
    pluralize(subject, args) {
      return `${subject}${args.length > 1 ? 's' : ''}`;
    },
    isRequired({ required }) {
      return required;
    },
    filterSelection(id) {
      return this.choiceSelections.filter((c) => c.id === id);
    },
    async commitSelection(event) {
      handleChoice(event);
      const { target: { dataset: { alternativeValue } } } = event;
      if (!alternativeValue) return '';
      const i = Number(alternativeValue);
      if (i > 1) {
        sessionStorage.removeItem('extensionSelected');
      }
      if (i === 0) {
        this.informedDelivery = false;
        sessionStorage.removeItem('informedDelivery');
      }
      if (!this.isRequired(this.filterSelection(i))) {
        this.choiceSelections = this.choiceSelections.filter((c) => c.id !== i);
      }
      if (i > 0) {
        this.removeExtensionSelected();
      }
      return '';
    },
    choiceSelectionRemovable(value) {
      return value === true;
    },
    asCurrency(value) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
      }).format(value);
    },
    formatZip9,
    parseAndFormatDate(str) {
      if (!str) return '';
      return format(parse(str, 'yyyy-MM-dd', new Date()), this.dateFormat);
    },
    // this will need to move to the COA class object so we can use it everywhere
    async hydrateCOA() {
      const { uuid, ...coa } = await this.$coa.coaGet() || {};
      if (uuid) {
        this.coa = coa;
        this.coa.uuid = uuid;
      }
      this.choiceSelections[0].cost = (this.icoaAmount / 100);

      if ((this.coa.forwardType === 'TEMPORARY' && !this.coa.multipleAddresses)
      || (this.coa.forwardType === 'TEMPORARY' && this.coa.multipleAddresses && this.coa.primaryBusiness)) {
        sessionStorage.removeItem('extension');
        sessionStorage.removeItem('extensionSelected');
      }
      if (this.coa.multipleAddresses) {
        await this.hydrateBusiness();
        await this.hydrateBusinessAddresses();

        // initially display primary
        this.displayPrimary();
      }

      if (this.coa.moverType === 'BUSINESS') {
        if (this.coa.multipleAddresses) {
          if (this.flagBusinessAliasEnabled && this.business.length) {
            this.choiceSelections[0].cost += (
              (this.business.filter((x) => !x.dcoa).length - 1)
               * this.icoaAmount) / 100;

            const aliasHandlers = [];
            this.business.forEach((b) => {
              if (!b.dcoa) {
                aliasHandlers.push(this.$coa.businessAliasGetAllByOrderId(b.orderId));
              }
            });

            const aliasResponses = await Promise.all(aliasHandlers);
            aliasResponses.forEach((aliasResponse) => {
              const { aliases } = aliasResponse;
              if (aliases?.length) {
                this.choiceSelections[0].cost += (aliases.length * this.icoaAmount) / 100;
              }
            });
          }
        } else {
          const { aliases } = this.flagBusinessAliasEnabled
            && await this.$coa.businessAliasGetAll();
          if (aliases?.length) {
            this.businessAliases = aliases.map(({ value }) => value);
            this.choiceSelections[0].cost += (aliases.length * this.icoaAmount) / 100;
          }
        }
        if (!this.bizCostComputationEnabled) {
          if (this.coa.multipleAddresses && !this.business.some((biz) => biz.dcoa === false)) {
            this.choiceSelections[0].cost = 0;
          } else {
            this.choiceSelections[0].cost = this.$store.get('icoaAmount') / 100;
          }
        }
      }
      if (this.coa.dcoa && (
        (this.coa.moverType === 'BUSINESS' && !this.coa.multipleAddresses)
        || this.coa.moverType !== 'BUSINESS')) { // for family and individual DCOA filers
        this.choiceSelections[0].cost = 0;
      }
    },
    async hydrateMover() {
      const { MOVER } = await this.$coa.personGetAll();
      if (MOVER) {
        this.mover = MOVER;
      }
    },
    async hydrateAddresses() {
      const { addresses } = await this.$coa.addressGetAll();
      const [address1, address2, address3] = addresses;
      [
        address1,
        address2,
        address3,
      ]
        .filter((a) => a)
        .forEach(({ addressType, ...address }) => {
          if (addressType === 'BILLING') return;

          // set the overrideAms data to the response used in the modalNewConstruction flow
          if (addressType === 'NEW') {
            const { overrideAms } = address;
            this.overrideAms = overrideAms;
          }

          this[`${addressType.toLowerCase()}Address`] = { addressType, ...address };
        });
    },
    displayPrimary() {
      const primary = this.business && this.business.length
          && this.business.filter((v) => v.primaryBusiness);
      if (primary.length) {
        const { orderId } = primary[0];
        this.populateBusiness(orderId);
      }
    },
    async next() {
      if (!await this.coaSync()) {
        return null;
      }
      this.$store.commit('ENABLE_LOADER');
      sessionStorage.setItem('autofill', this.autofill);
      sessionStorage.setItem('myMoveChoicePrefillOptIn', this.myMoveChoicePrefillOptIn);
      sessionStorage.setItem('myMovePrefillOptIn', this.myMovePrefillOptIn);
      sessionStorage.setItem('extensionSelected', this.extensionSelected);

      const busDCOA = this.business?.filter((bus) => bus.dcoa === false);
      if (this.businessDCOA && busDCOA.length === 0) {
        const cuid = await this.$coa.verifyBusinessDCOA();
        return this.$router.push({
          name: 'action',
          query: {
            cuid,
            coa_uuid: this.$coa.coaUUID,
          },
        });
      }

      if (this.verifyAge) {
        return this.$router.push({ name: 'age-verification' });
      }

      if (this.flagAmpersendEnabled) {
        const currentDate = new Date();
        // // calculate # of days
        const mgoMoveDifferential = Math.ceil(
          (new Date(this.coa.startDate) - currentDate) / 86_400_000,
        );
        this.$amp.identify({
          prefillOptIn: JSON.parse(sessionStorage.getItem('mmcpfill')) || this.autofill || false,
          mgoMoveDifferential,
        });
      }

      return this.$router.push({ name: 'identity-check', query: this.$route.query });
    },
    populateAddresses(addresses) {
      const [address1, address2, address3] = addresses;
      [
        address1,
        address2,
        address3,
      ]
        .filter((a) => a)
        .forEach(({ addressType, ...address }) => {
          if (addressType === 'BILLING') return;

          // set the overrideAms data to the response used in the modalNewConstruction flow
          if (addressType === 'NEW') {
            const { overrideAms } = address;
            this.overrideAms = overrideAms;
          }

          this[`${addressType.toLowerCase()}Address`] = { addressType, ...address };
        });
    },
    async populateBusiness(orderId) {
      this.orderId = orderId;
      const filteredCoa = this.business && this.business.length
                                 && this.business.filter((v) => v.orderId === orderId);
      const selectedCoa = filteredCoa[0];
      const selectedAddress = this.busAddresses?.addresses
        .filter((a) => a && a.orderId === orderId);

      if (selectedCoa) {
        // remove any values that would transfer over
        this.coa = {};
        Object.keys(selectedCoa).forEach((prop) => {
          if (selectedCoa[prop]) {
            this.coa[prop] = selectedCoa[prop];
          }
        });
      }
      this.populateAddresses(selectedAddress[0]?.addresses);
      const { aliases } = this.flagBusinessAliasEnabled
        && await this.$coa.businessAliasGetAllByOrderId(orderId);

      if (aliases?.length) {
        // open businessAlias dropdown
        this.showBusinessAlias = true;
        this.businessAliases = aliases.map((alias) => alias.value);
      } else {
        this.businessAliases = [];
      }
      this.scrollToElement('#business-name');
    },
    async hydrateBusiness() {
      this.business = await this.$coa.businessGetAll();
    },
    async hydrateBusinessAddresses() {
      this.busAddresses = await this.$coa.busAddrGetAll();
    },
    async scrollToElement(cssSelector) {
      const errorHTML = document.querySelector(cssSelector);
      if (errorHTML !== null) {
        setTimeout(() => {
          errorHTML.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 100);
      }
    },
    editPagePathParam() {
      const param = this.orderId ? `/${this.orderId}` : '';
      return param;
    },
  },
};
